import { Route } from '@angular/router';
import { authGuard } from '@dental-ui/auth';
import { PortalShellComponent, PortalNotAuthorizedComponent, portalAdminGuard } from '@dental-ui/portal-shell';
import { PortalDashboardComponent } from '@dental-ui/portal-dashboard';
import { PortalResourceListComponent } from '@dental-ui/portal-resource-list';
import { PortalStaticFilesComponent } from '@dental-ui/portal-static-files';
import { PortalPackagesComponent } from '@dental-ui/portal-packages';
import { PortalPackageContentsComponent } from '@dental-ui/portal-package-contents';
import { PortalMachineTypesComponent } from '@dental-ui/portal-machine-types';
import { PortalBrandsComponent } from '@dental-ui/portal-brands';
import { PortalMachineModelsComponent } from '@dental-ui/portal-machine-models';

export const appRoutes: Route[] = [
  {
    path: 'not-authorized',
    component: PortalNotAuthorizedComponent,
  },
  {
    path: '',
    component: PortalShellComponent,
    canActivate: [authGuard, portalAdminGuard],
    children: [
      {
        path: '',
        component: PortalDashboardComponent,
        pathMatch: 'full',
      },
      {
        path: 'static-files',
        component: PortalStaticFilesComponent,
      },
      {
        path: 'packages',
        component: PortalPackagesComponent,
      },
      {
        path: 'package-contents',
        component: PortalPackageContentsComponent,
      },
      {
        path: 'machine-types',
        component: PortalMachineTypesComponent,
      },
      {
        path: 'brands',
        component: PortalBrandsComponent,
      },
      {
        path: 'machine-models',
        component: PortalMachineModelsComponent,
      },
      {
        path: ':resource',
        component: PortalResourceListComponent,
      },
    ],
  },
];
